import { render } from "./DocLink.vue?vue&type=template&id=d14f659e"
import script from "./DocLink.vue?vue&type=script&lang=js"
export * from "./DocLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__